import React, { Component } from 'react';

import './formImageField.css';

export default class ImageField extends Component {
  render() {
    const { input: {value, onChange}, label } = this.props;

    return(
      <div className='fieldWrapper'>
        <div className='pictureFilled' style={{backgroundImage: `url(${value})`, backgroundSize: 'contain', backgroundRepeat: 'no-repeat', backgroundPosition: "50% 50%"}}/>
        <label className={value ? "pictureUpload filled" : "pictureUpload"}>
          <input id={label} className="pictureEmpty" type="file" accept="image/*" onChange={this.props.onChange} />
          <div className="mdi mdi-camera"></div>
          <div>{label}</div>
        </label>
      </div>
    )
  }
}
